import initSharedCalendarsConfiguration from 'owa-shared-calendars-option/lib/orchestration/initSharedCalendarsConfiguration';
import SharedCalendarsOption from 'owa-shared-calendars-option/lib/SharedCalendarsOption';
var sharedCalendarsSubCategory = {
    key: 'SharedCalendars',
    titleStringKey: 'optionSubcategory_sharedCalendars',
    options: [SharedCalendarsOption],
    onSelected: initSharedCalendarsConfiguration,
};
export default sharedCalendarsSubCategory;
//# sourceMappingURL=sharedCalendarsSubCategory.js.map